const ROOT = 'POOLS_';

const actions = {
  LOAD_AGENCIES_REQUEST: `${ROOT}LOAD_AGENCIES_REQUEST`,
  LOAD_AGENCIES_SUCCESS: `${ROOT}LOAD_AGENCIES_SUCCESS`,
  LOAD_AGENCIES_ERROR: `${ROOT}LOAD_AGENCIES_ERROR`,
  LOAD_ALL_AVAILABLE_AGENCIES_REQUEST: `${ROOT}LOAD_ALL_AVAILABLE_AGENCIES_REQUEST`,
  LOAD_ALL_AVAILABLE_SUCCESS: `${ROOT}LOAD_ALL_AVAILABLE_SUCCESS`,
  LOAD_ALL_AVAILABLE_ERROR: `${ROOT}LOAD_ALL_AVAILABLE_ERROR`,
  PROCESS_ACTION_REQUEST: `${ROOT}PROCESS_ACTION_REQUEST`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actions;
